export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

      var $hamburger = $(".hamburger");
      $hamburger.on("click", function() {
          $hamburger.toggleClass("is-active");
          $('#header').toggleClass("open-nav");
      });

      if($('.main').height() <= 260 && $(window).width() > 425 ) {
          $('#footer').addClass('fixed-bottom');
      }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js